<script>
  import fileTemplateState from "../../stores/fileTemplateJsonData"
  import { push } from "svelte-spa-router"
  import { copyToClipboard } from "../../../../../Pages/Publish/SinglePublish/script"
  import notify from "../../../../../Script/notify"
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()

  /**
   * @type {copiedInfo}
   */
  let copiedInfo = {
    close() {},
  }
  export let template

  const goInitialState = () => {
    $fileTemplateState = {
      documentTemplateId: undefined,
      documentTempName: "None",
      baseImageUploadModal: false,
      runWatcher: false,
      baseImageInfo: {},
      fonts: [],
      activeFontFamily: "Arial",
      operations: [],
      tempOperation: [],
      download: false,
      canvasScale: 0,
      canvasHeight: 0,
      parsedJson: {},
      templateDel: false,
      apiFonts: [],
      goBack: false,
      showImageSection: false,
      footerArray: ["You can change the quality in settings", "Add or Edit, Text, Image and qr elements", "You can Add custom fonts for text layers", "You can Able to change File template name", "Able to Download the canvas"],
    }
    localStorage.setItem("P2BFileTempEditor", JSON.stringify($fileTemplateState))
    // ($fileTemplateState)
  }
</script>

<!-- card list -->
<div class="h-full w-full hover:shadow-md dark:border-2 dark:border-transparent dark:hover:rounded-md dark:hover:border-blue-500">
  <div class="group relative flex h-[70%] w-full items-center justify-center rounded-t-md bg-mdGray">
    <img src={template.uri} alt="certificate" class="aspect-auto h-auto max-h-full select-none rounded-md" />
    <div class="absolute inset-0 hidden items-center justify-center gap-3 rounded-md bg-[#000000cc] px-3 md:group-hover:flex">
      <button
        on:click={() => {
          copiedInfo.close()
          copyToClipboard(template.id)
          copiedInfo = notify.info("Template ID Copied to clipboard")
        }}
        data-tooltip="Copy"
        tooltip-position="top"
        class="flex h-8 w-8 select-none items-center justify-center rounded-full border border-transparent text-sm font-medium text-gray-300 hover:bg-sky-600 hover:text-white focus:outline-none active:text-white"
      >
        <i class="fa-solid fa-copy" />
      </button>

      <button
        on:click={() => {
          goInitialState()
          push(`/templates/file/edit?id=${template.id}`)
        }}
        data-tooltip="Edit"
        tooltip-position="top"
        class="flex h-8 w-8 select-none items-center justify-center rounded-full border border-transparent text-sm font-medium text-gray-300 hover:bg-yellow-500 hover:text-white focus:outline-none active:text-white"
      >
        <i class="fa-solid fa-pen-field" />
      </button>
      <button on:click={() => dispatch("onDuplicate")} data-tooltip="Duplicate" tooltip-position="top" class="flex h-8 w-8 select-none items-center justify-center rounded-full border border-transparent text-sm font-medium text-gray-300 hover:bg-emerald-500 hover:text-white focus:outline-none active:bg-emerald-400">
        <i class="fa-solid fa-clone" />
      </button>
      <button data-tooltip="Delete" tooltip-position="top" on:click class="flex h-8 w-8 select-none items-center justify-center rounded-full border border-transparent text-sm font-medium text-gray-300 hover:bg-red-600 hover:text-white focus:outline-none active:text-white">
        <i class="fa-solid fa-trash-can" />
      </button>
    </div>
  </div>
  <div class="flex justify-between md:hidden">
    <button
      on:click={() => {
        $fileTemplateState.baseImageUploadModal = false
        push(`/templates/file/edit?id=${template.id}`)
      }}
      class="flex h-8 w-8 select-none items-center justify-center rounded-full border border-transparent text-sm font-medium text-gray-300 hover:bg-yellow-500 hover:text-white focus:outline-none active:text-yellow-800"
    >
      <i class="fa-solid fa-pen-field" />
    </button>
    <button on:click={() => dispatch("onDuplicate")} class="flex h-8 w-8 select-none items-center justify-center rounded-full border border-transparent text-sm font-medium text-gray-300 hover:bg-yellow-500 hover:text-white focus:outline-none active:text-yellow-800">
      <i class="fa-solid fa-clone" />
    </button>
    <button on:click class="flex h-8 w-8 select-none items-center justify-center rounded-full border border-transparent text-sm font-medium text-gray-300 hover:bg-red-600 hover:text-white focus:outline-none active:text-red-900">
      <i class="fa-solid fa-trash-can" />
    </button>
  </div>
  <div class="h-[30%] -translate-y-0.5 space-y-1 rounded-b-md bg-white p-3 dark:bg-lightgray">
    <h1 title={template.name} class="w-4/5 select-none truncate break-words text-sm font-bold text-black dark:text-white md:text-lg">
      {template.name}
    </h1>
    <p class="select-none truncate text-xs font-medium text-gray-500 md:text-sm">
      <!-- {new Date(template.created).toString().slice(0, 24)} -->
      {new Date(template.modified || template.created).toString().slice(0, 24)}
    </p>
  </div>
</div>
